import { OrmModel } from "@natiwi/core/models/model";

export class OrmContainer extends OrmModel {

}